import { defineComponent as _defineComponent } from 'vue'
import BaseDialog from "@/components/base-dialog.vue";
import { ref } from "vue";
import { OnlineAnswersheetAttachment } from "@/composables/online-answersheet/use-online-answersheet-attachments";
import FilePreviewerDialog from "./file-previewer-dialog.vue";
import { MessageBox } from "element-ui";

import TrashIcon from "@/assets/icons/svg/trash-icon.svg";
import PaperClipIcon from "@/assets/icons/svg/paper-clip.icon.svg";

//TODO: This version of filesize is very old, consider doing an major update to filesize in a separate issue!
//@ts-ignore
import fileSize from "filesize";
import useHttpRequest from "@/composables/use-http-request";
import CourseWork from "@/interfaces/courseWork.interface";
import AddCourseWorkAttachmentDialog from "./add-course-work-attachment-dialog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'course-work-attachments-dialog',
  props: {
    isVisible: { type: Boolean },
    attachments: null,
    courseWork: null,
    onClose: null
  },
  emits: {
  "attachment-added": (attachment: OnlineAnswersheetAttachment) => !!attachment,
  "attachment-removed": (id: string) => !!id,
},
  setup(__props: any, { emit }) {

const props = __props as {
  isVisible: boolean;
  attachments: OnlineAnswersheetAttachment[];
  courseWork: CourseWork | null;
  onClose: () => void;
}



const closeDialog = () => {
  props.onClose();
};



const addAttachmentDialogVisible = ref(false);
const onAttachFileIntent = () => {
  closeDialog();
  addAttachmentDialogVisible.value = true;
};

const onAttachmentAdded = (attachment: OnlineAnswersheetAttachment) => {
  emit("attachment-added", attachment);
};

const onRemoveAttachment = async (id: string) => {
  try {
    await MessageBox.confirm(
      "Are you sure you want to remove this attachment?",
      "Remove Attachment",
      {
        // eslint-disable-line no-unreachable
        confirmButtonText: "Yes Remove",
        cancelButtonText: "Cancel",
        confirmButtonClass: "el-confirm-btn-danger",
        type: "warning",
      }
    );

    const courseWorkSubmission =
      props.courseWork?.student_course_work_submissions?.[0];

    const deleted = await useHttpRequest<{
      success: boolean;
      message: string;
    }>({
      method: "DELETE",
      url: `course-work/attachments/delete-one?student_course_work_submission_id=${courseWorkSubmission?.student_course_work_submission_id}&uuid=${id}`,
      loadingProperty: null,
      showSuccessMessage: false,
      errorLoadingProperty: null,
      showFullScreenLoader: true,
    });

    if (!deleted) {
      return;
    }

    if (
      deleted.success &&
      deleted.message == "Attachment deleted successfully"
    ) {
      emit("attachment-removed", id);
    }
  } catch (error) {
    //No need to do anything
  }
};

const filePreviewerDialogVisible = ref(false);
const previewFilePathUrl = ref("");
const previewFileName = ref("");

const onPreviewFile = (filePath: string, fileName: string) => {
  previewFilePathUrl.value = filePath;
  previewFileName.value = fileName;
  filePreviewerDialogVisible.value = true;
};

return { __sfc: true,props, closeDialog, emit, addAttachmentDialogVisible, onAttachFileIntent, onAttachmentAdded, onRemoveAttachment, filePreviewerDialogVisible, previewFilePathUrl, previewFileName, onPreviewFile, BaseDialog, FilePreviewerDialog, TrashIcon, PaperClipIcon, fileSize, AddCourseWorkAttachmentDialog }
}

})